import { ChatMessageModel } from '@/components/chat/_domain/models';

const MESSAGE_LIST_CLEANER_INTERVAL_MILLISECONDS: number = 30000;

class ChatBuffer {
  private bufferCleanupIntervalTimerHandle: number;
  private latestMessageId: number = 0;

  constructor(private readonly messageList: ChatMessageModel[], private readonly maxChatBufferSize: number, private readonly cleanupTimeoutInMilliseconds = MESSAGE_LIST_CLEANER_INTERVAL_MILLISECONDS) {
    this.initialiseBufferCleanupIntervalTimer();
  }

  public canPushMessage(message: ChatMessageModel): boolean {
    if (message) {
      return message.id > this.latestMessageId;
    }
    return false;
  }

  public empty(): void {
    this.messageList.splice(0);
    this.latestMessageId = this.findLatestMessageId();
  }

  public push(...messages: ChatMessageModel[]): void {
    this.messageList.push(...messages);
    this.latestMessageId = this.findLatestMessageId();
  }

  public toArray(): ChatMessageModel[] {
    return this.messageList;
  }

  public dispose() {
    window.clearInterval(this.bufferCleanupIntervalTimerHandle);
    this.empty();
  }

  private initialiseBufferCleanupIntervalTimer(): void {
    this.bufferCleanupIntervalTimerHandle = window.setInterval(this.cleanupChatBuffer.bind(this), this.cleanupTimeoutInMilliseconds);
  }

  private cleanupChatBuffer() {
    const numberOfMessagesToDrop = this.messageList.length - this.maxChatBufferSize;
    if (numberOfMessagesToDrop > 0) {
      this.messageList.splice(0, numberOfMessagesToDrop);
    }
  }

  private findLatestMessageId(): number {
    if (this.messageList.length > 0) {
      const latestMessage = this.messageList[this.messageList.length - 1];
      return latestMessage.id;
    }
    return 0;
  }
}

export { ChatBuffer };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/modules/chat-buffer/chat-buffer.ts